import React from "react";
import { LayersControl, TileLayer, useMapEvents } from "react-leaflet";

const BASEMAP_KEY = "fw_basemap";

function BaseLayerSaver() {
  useMapEvents({
    baselayerchange: (e) => {
      try { localStorage.setItem(BASEMAP_KEY, e.name); } catch { /* noop */ }
    },
  });
  return null;
}

const GOOGLE_ATTR = "Map data &copy; <a href=\"https://www.google.com/intl/en_us/help/legalnotices_maps.html\">Google</a>";

const BASE_LAYERS = [
  {
    name: "Google Streets",
    checked: true,
    attribution: GOOGLE_ATTR,
    url: "https://mt{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
    subdomains: "0123",
    maxZoom: 20,
  },
  {
    name: "Topographic",
    attribution: "Tiles &copy; Esri — Esri, USGS, NOAA",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
    maxZoom: 19,
  },
  {
    name: "Google Satellite",
    attribution: GOOGLE_ATTR,
    url: "https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
    subdomains: "0123",
    maxZoom: 20,
  },
  {
    name: "Google Hybrid",
    attribution: GOOGLE_ATTR,
    url: "https://mt{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
    subdomains: "0123",
    maxZoom: 20,
  },
  {
    name: "Google Terrain",
    attribution: GOOGLE_ATTR,
    url: "https://mt{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
    subdomains: "0123",
    maxZoom: 20,
  },
  {
    name: "Esri Satellite",
    attribution: "Tiles &copy; Esri — Maxar, Earthstar Geographics, USGS",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    maxZoom: 19,
  },
  {
    name: "OpenTopoMap",
    attribution: "&copy; OpenTopoMap (CC-BY-SA), SRTM | &copy; OpenStreetMap",
    url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
    subdomains: "abc",
    maxZoom: 17,
  },
  {
    name: "Dark Tactical",
    attribution: "&copy; OpenStreetMap, &copy; CARTO",
    url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
    subdomains: "abcd",
    maxZoom: 19,
  },
];

export default function MapBaseLayers() {
  let saved = null;
  try { saved = localStorage.getItem(BASEMAP_KEY); } catch { /* noop */ }
  const validSaved = BASE_LAYERS.some((l) => l.name === saved) ? saved : null;
  return (
    <>
      <BaseLayerSaver />
      <LayersControl position="topright">
        {BASE_LAYERS.map((l) => (
          <LayersControl.BaseLayer
            key={l.name}
            name={l.name}
            checked={validSaved ? l.name === validSaved : !!l.checked}
          >
          {l.subdomains ? (
            <TileLayer
              attribution={l.attribution}
              url={l.url}
              subdomains={l.subdomains}
              maxZoom={l.maxZoom}
            />
          ) : (
            <TileLayer
              attribution={l.attribution}
              url={l.url}
              maxZoom={l.maxZoom}
            />
          )}
          </LayersControl.BaseLayer>
        ))}
      </LayersControl>
    </>
  );
}
